
import React from 'react';
import { Button } from '@/components/ui/button';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { SentimentType } from '@/data/industryData';

interface SentimentSelectorProps {
  isPositive: boolean;
  setIsPositive: (isPositive: boolean) => void;
}

const SentimentSelector: React.FC<SentimentSelectorProps> = ({ isPositive, setIsPositive }) => {
  return (
    <div className="flex items-center justify-center gap-3 mb-4">
      <Button 
        variant={isPositive ? "default" : "outline"} 
        size="sm"
        className={isPositive ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIsPositive(true)}
      >
        <ThumbsUp size={16} className="mr-1" />
        Avis positif
      </Button>
      <Button 
        variant={!isPositive ? "default" : "outline"} 
        size="sm"
        className={!isPositive ? "bg-slate-700 hover:bg-slate-800" : "border-slate-300 text-slate-700"}
        onClick={() => setIsPositive(false)}
      >
        <ThumbsDown size={16} className="mr-1" />
        Avis négatif
      </Button>
    </div>
  );
};

export default SentimentSelector;
